module.exports = __webpack_public_path__ + "static/results6.jpg";